"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.myActivityQuerySchema = exports.uploadMyDocumentSchema = exports.USER_DOCUMENT_TYPES = exports.preferencesUiUpsertSchema = exports.notificationPreferenceUpsertSchema = exports.selfTrustedDeviceRenameSchema = exports.selfMfaVerifyEnrollmentSchema = exports.changeMyPasswordSchema = exports.updateMyProfileSchema = void 0;
const zod_1 = require("zod");
// Mirrors core/authentication/password.service.ts's policy regex — same
// duplication convention as user.schema.ts's resetPasswordSchema.
const PASSWORD_POLICY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
const TIME_HH_MM_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;
/**
 * ADR-033 Decision 7 — the field allowlist itself IS the enforcement.
 * Role/Department/Designation/Hospital/Employee ID/Branch/Payroll/
 * Permissions have no key here, so they cannot be submitted at all
 * (not "submitted but ignored") — admin editing of those fields stays
 * on the existing PATCH /users/:id, untouched.
 */
exports.updateMyProfileSchema = zod_1.z.object({
    gender: zod_1.z.string().max(20).nullable().optional(),
    dateOfBirth: zod_1.z.coerce.date().nullable().optional(),
    bloodGroup: zod_1.z.string().max(10).nullable().optional(),
    mobilePhone: zod_1.z.string().max(20).nullable().optional(),
    emergencyContactName: zod_1.z.string().max(150).nullable().optional(),
    emergencyContactPhone: zod_1.z.string().max(20).nullable().optional(),
    personalEmail: zod_1.z.string().email().max(255).nullable().optional(),
    addressLine1: zod_1.z.string().max(255).nullable().optional(),
    addressLine2: zod_1.z.string().max(255).nullable().optional(),
    city: zod_1.z.string().max(100).nullable().optional(),
    state: zod_1.z.string().max(100).nullable().optional(),
    postalCode: zod_1.z.string().max(20).nullable().optional(),
    country: zod_1.z.string().max(100).nullable().optional(),
    language: zod_1.z.string().max(20).nullable().optional(),
    timezone: zod_1.z.string().max(50).nullable().optional(),
    qualification: zod_1.z.string().max(255).nullable().optional(),
    experienceYears: zod_1.z.number().int().min(0).max(80).nullable().optional(),
    professionalRegistrations: zod_1.z
        .array(zod_1.z.object({
        type: zod_1.z.string().min(1).max(100),
        number: zod_1.z.string().min(1).max(100),
        issuedBy: zod_1.z.string().max(150).optional(),
        expiryDate: zod_1.z.coerce.date().optional(),
    }))
        .nullable()
        .optional(),
});
exports.changeMyPasswordSchema = zod_1.z.object({
    currentPassword: zod_1.z.string().min(1),
    newPassword: zod_1.z.string().regex(PASSWORD_POLICY_REGEX, 'Password does not meet the complexity policy'),
});
/** Self-initiated enroll (Security tab) — distinct from the login-triggered challenge in user.schema.ts's mfaVerifySchema, which carries a challenge token this flow doesn't have (the caller is already authenticated). */
exports.selfMfaVerifyEnrollmentSchema = zod_1.z.object({
    code: zod_1.z.string().regex(/^\d{6}$/),
});
exports.selfTrustedDeviceRenameSchema = zod_1.z.object({
    deviceLabel: zod_1.z.string().min(1).max(150),
});
exports.notificationPreferenceUpsertSchema = zod_1.z.object({
    channelsByCategory: zod_1.z.record(zod_1.z.string(), zod_1.z.object({
        email: zod_1.z.boolean(),
        sms: zod_1.z.boolean(),
        push: zod_1.z.boolean(),
        inApp: zod_1.z.boolean(),
    })),
    muteHoursStart: zod_1.z.string().regex(TIME_HH_MM_REGEX).nullable().optional(),
    muteHoursEnd: zod_1.z.string().regex(TIME_HH_MM_REGEX).nullable().optional(),
});
exports.preferencesUiUpsertSchema = zod_1.z.object({
    theme: zod_1.z.string().max(20).nullable().optional(),
    sidebarCollapsed: zod_1.z.boolean().nullable().optional(),
    language: zod_1.z.string().max(20).nullable().optional(),
    dateFormat: zod_1.z.string().max(30).nullable().optional(),
    rowsPerPage: zod_1.z.number().int().positive().max(500).nullable().optional(),
    landingPage: zod_1.z.string().max(255).nullable().optional(),
    defaultBranchId: zod_1.z.string().uuid().nullable().optional(),
    defaultDepartmentId: zod_1.z.string().uuid().nullable().optional(),
});
/** Mirrors the Prisma UserDocumentType enum (schema.prisma) — duplicated deliberately, contracts must not depend on @prisma/client. */
exports.USER_DOCUMENT_TYPES = [
    'PROFILE_PHOTO',
    'SIGNATURE',
    'CERTIFICATE',
    'MEDICAL_LICENSE',
    'IDENTITY_PROOF',
    'EDUCATION',
    'EMPLOYMENT',
];
exports.uploadMyDocumentSchema = zod_1.z.object({
    documentType: zod_1.z.enum(exports.USER_DOCUMENT_TYPES),
});
exports.myActivityQuerySchema = zod_1.z.object({
    dateFrom: zod_1.z.coerce.date().optional(),
    dateTo: zod_1.z.coerce.date().optional(),
    action: zod_1.z.string().max(100).optional(),
});
//# sourceMappingURL=profile.schema.js.map